<template>
    <div id="active_assets">
      
      <m-p-asset-menu-header
         :title="getTitle"
      ></m-p-asset-menu-header>

      <div id="active_asset_container" class="asset-wrapper">
            <div v-if="assets.length === 0" class="no-assets">
               <span v-if="currSelectedAssetType !== 6">No active {{getAssetString(currSelectedAssetType)}} assets.</span>
               <span v-else>No active feeds.</span>
            </div> 
            <!-- <div class="asset-row" v-for="i in rowCount" :key="i">
               <m-p-asset
                  v-for="(asset, index) in assetCountInRow(i)"
                  :key="asset.recid"
                  :asset="asset"
                  :assetType="assetType"
                  :index="index"
               ></m-p-asset>
            </div> -->
            <div v-if="currSelectedAssetType != 3 && currSelectedAssetType != 8" >
               <div class="asset-row" v-for="i in rowCount" :key="i">
                  <m-p-asset
                     v-for="(asset, index) in assetCountInRow(i)"
                     :key="asset.recid"
                     :asset="asset"
                     :isActive="activeAssetId == asset.recid"
                     :index="index"
                     :playingIndex="audioPlayingIndex"
                     @play="handlePlay" 
                     @pause="handlePause"
                  ></m-p-asset>
               </div>
            </div>
            <div v-else-if="currSelectedAssetType == 3">
               <m-p-audio-asset
                  v-for="(asset, index) in assets"
                  :key="asset.recid"
                  :asset="asset"
                  :isActive="activeAssetId == asset.recid"
                  :index="index"
                  :playingIndex="audioPlayingIndex"
                  @play="handlePlay" 
                  @pause="handlePause"
               ></m-p-audio-asset>
            </div>
            <div v-else-if="currSelectedAssetType == 8">
               <m-p-weblink-asset
                  v-for="(asset, index) in assets"
                  :key="asset.recid"
                  :asset="asset"
                  :isActive="activeAssetId == asset.recid"
               ></m-p-weblink-asset>
            </div>

            <div v-if="activeMore" class="show-more-container">
               <div class="show-more-text" @click="showMore">Show More</div>
            </div>
      </div>
   </div>
</template>

<script>
import MPAssetMenuHeader from './MPAssetMenuHeader';
import MPAsset from './MPAsset';
import MPAudioAsset from './MPAudioAsset';
import BaseMPAssets from './BaseMPAssets';
import MPWeblinkAsset from './MPWeblinkAsset';

import { mapActions, mapState } from 'vuex';

export default {
   extends: BaseMPAssets,

   computed: {
      ...mapState('global', [
         'mpActiveAssets',
         'isLoadingActive',
         'activeMore',
         'mpActivePage'
      ]),

      assets() {
         return this.mpActiveAssets;
      },

      getTitle() {
         let assetStr = this.getAssetString(this.currSelectedAssetType);
         if (assetStr === 'image' || assetStr === 'movie' || assetStr === 'instance') {
            return 'Active ' + assetStr + 's';
         } else {
            return 'Active ' + assetStr;
         }
      }
   },

   methods:{
      ...mapActions('global', ['fetchActiveMedia']),

      getAssets(refresh=false) {
         this.fetchActiveMedia({ vm: this, refresh });
         //get the assets
         // let self = this;
         // if (this.assetType === 10) {
         //    //get templates associated with channel
         //    $.post(
         //       this.BARD_HOST + '/tmpl/list',
         //       {
         //          'token'      : localStorage.getItem('token'),
         //          'chanRecid' : this.channelRecid
         //       }, function(data) {
         //          //get instances for each template
         //          if (!data.error) {
         //             let templates = data;
         //             for (let t of templates) {
         //                $.post(
         //                   self.BARD_HOST + '/instance/list',
         //                   {
         //                      'token'      : localStorage.getItem('token'),
         //                      'tmplRecid' : t.recid,
         //                      'limit' : 12
         //                   }, function(data) {
         //                      if (!data.error) {
         //                         self.assets = data.instances;
         //                      } else {
         //                         self.handleFailedAPICall('/instance/list', 'MPActiveAssets', data);
         //                      }
         //                   }
         //                ).fail((e) => {
         //                   console.log("Error with call /instance/list in MPActiveAssets: " + error.responseText);
         //                });
         //             }
         //          } else {
         //             self.handleFailedAPICall('/instance/list', 'MPActiveAssets', data);
         //          }
         //       }
         //    ); 
         // } else {
         //    $.post(
         //       this.BARD_HOST + '/' + this.getAssetString(this.assetType) + '/active',
         //       {
         //          'token'      : localStorage.getItem('token'),
         //          'limit' : 20,
         //          'page'  : this.page,
         //          'channelRecid' : this.channelRecid != undefined ? this.channelRecid: 0
         //       }, function(data) {
         //          if (!data.error) {
         //             if (data.length < 20) {
         //                self.moreToShow = false;
         //             } else {
         //                self.moreToShow = true;
         //             }
         //             if (self.page > 1) {
         //                self.assets = self.assets.concat(data);
         //             } else {
         //                self.assets = data;
         //             }
         //          } else {
         //             self.handleFailedAPICall('/' + this.getAssetString(this.assetType) + '/active', 'MPActiveAssets', data);
         //          }
         //       }
         //    ).fail((e) => {
         //       console.log("Error with call /" + this.getAssetString(this.assetType) + "/list in MPActiveAssets: " + error.responseText);
         //    });
         //}
      }
   },

   components: {
      MPAssetMenuHeader,
      MPAsset,
      MPWeblinkAsset,
      MPAudioAsset
   }
}
</script>

<style lang="scss" >

#active_assets {
   padding-right: 25px;
}

</style>
